const mobileMenuContainer = document.querySelector(".site-nav__icons");
const mMenuChildren = mobileMenuContainer.children
mobileMenuContainer.style.display = "flex";
mobileMenuContainer.style.flexDirection = "row"
const menuNames = ["Search", "Menu", "Cart"]
for (let i = 0; mMenuChildren.length > i; i++) {
  const menuC = mMenuChildren[i]
  menuC.style.textAlign = "center";
  menuC.style.display = "flex";
  menuC.style.justifyContent = "center";
  menuC.style.flexDirection = "column"
  menuC.children[0].style.margin = "auto"
  const sEl = document.createElement("span");
  sEl.style.fontSize = "12px";
  const nText = document.createTextNode(menuNames[i]);
  sEl.appendChild(nText)
  menuC.appendChild(sEl)
}

